import FAIcon from './FAIcon';
import DuoToneFAIcon from './DuoToneFAIcon';

export { FAIcon, DuoToneFAIcon };
